import Lottie from "lottie-react";
import Bot from "../../HelloAnimation.json";

export const HelloAnimation = () => (
  <Lottie animationData={Bot} loop={true} style={{ width: 100, height: 100 }} />
);
